import { render, staticRenderFns } from "./contaCorrenteDispesas.vue?vue&type=template&id=567d7aec&scoped=true&"
import script from "./contaCorrenteDispesas.vue?vue&type=script&lang=js&"
export * from "./contaCorrenteDispesas.vue?vue&type=script&lang=js&"
import style0 from "./contaCorrenteDispesas.vue?vue&type=style&index=0&id=567d7aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567d7aec",
  null
  
)

export default component.exports